import React, {
    memo,
    Fragment
} from 'react';

const NonBreakingText = memo(function NonBreakingText({value}) {
    if (!value) {
        return null;
    }

    const words = value.split(' ');
    const children = _.reduce(words, (memo, word, idx) => {
        const toAppend = [<Fragment key={idx}>{word}</Fragment>];
        if (idx < _.size(words) - 1) {
            toAppend.push(<Fragment key={`nbsp-${idx}`}>&nbsp;</Fragment>);
        }
        return memo.concat(toAppend);
    }, []);

    return <>{children}</>;
});

export default function MetricTimePeriodHeaderTitle({metric, timePeriod}) {
    return (
        <>
            <NonBreakingText value={metric}/>,
            <br/>
            <NonBreakingText value={timePeriod}/>
        </>
    );
}
